var _path, _path2, _polygon, _path3, _circle, _circle2, _circle3, _rect, _rect2, _rect3, _polygon2, _path4, _circle4, _circle5, _circle6, _rect4, _rect5, _rect6, _polygon3, _path5, _circle7, _circle8, _circle9, _rect7, _rect8, _rect9, _polygon4, _path6, _polygon5, _path7, _path8, _circle10, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawSelectOptionReU4Qn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 886.11499,
    height: 652.3825,
    viewBox: "0 0 886.11499 652.3825",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M911,774.062v-72.34S939.19167,753.008,911,774.062Z",
    transform: "translate(-156.9425 -123.80875)",
    fill: "#f1f1f1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M912.74147,774.0493l-53.28963-48.92125S916.297,739.04359,912.74147,774.0493Z",
    transform: "translate(-156.9425 -123.80875)",
    fill: "#f1f1f1"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "191.188 0 63.729 0 0 110.382 63.729 220.765 191.188 220.765 254.917 110.382 191.188 0",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227.825,332.18352H340.977l56.576-97.99246L340.977,136.1986H227.825l-56.576,97.99246Z",
    transform: "translate(-156.9425 -123.80875)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.51589,
    cy: 81.14999,
    r: 5.22006,
    fill: "#e2e2e2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.51589,
    cy: 110.38231,
    r: 5.22006,
    fill: "#e2e2e2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.51589,
    cy: 139.61462,
    r: 5.22006,
    fill: "#e2e2e2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91.44012,
    y: 76.97395,
    width: 99.18107,
    height: 8.35209,
    fill: "#e2e2e2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 91.44012,
    y: 106.20626,
    width: 99.18107,
    height: 8.35209,
    fill: "#e2e2e2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 91.44012,
    y: 135.43858,
    width: 99.18107,
    height: 8.3521,
    fill: "#e2e2e2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "822.386 0 694.927 0 631.198 110.382 694.927 220.765 822.386 220.765 886.115 110.382 822.386 0",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M859.0228,332.18352h113.152l56.576-97.99246-56.576-97.99246H859.0228l-56.576,97.99246Z",
    transform: "translate(-156.9425 -123.80875)",
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 700.71368,
    cy: 81.14999,
    r: 5.22005,
    fill: "#e2e2e2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 700.71368,
    cy: 110.38231,
    r: 5.22005,
    fill: "#e2e2e2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 700.71368,
    cy: 139.61462,
    r: 5.22005,
    fill: "#e2e2e2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 722.63794,
    y: 76.97395,
    width: 99.18103,
    height: 8.35209,
    fill: "#e2e2e2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 722.63794,
    y: 106.20626,
    width: 99.18103,
    height: 8.35209,
    fill: "#e2e2e2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 722.63794,
    y: 135.43858,
    width: 99.18103,
    height: 8.3521,
    fill: "#e2e2e2"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "506.167 1.072 379.946 1.072 316.836 110.382 379.946 219.693 506.167 219.693 569.279 110.382 506.167 1.072",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M543.97324,331.23189H656.0264L712.053,234.19107,656.0264,137.15024H543.97324l-56.02655,97.04082Z",
    transform: "translate(-156.9425 -123.80875)",
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.6774,
    cy: 81.43388,
    r: 5.16936,
    fill: "#ff6600"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.6774,
    cy: 110.38231,
    r: 5.16936,
    fill: "#ff6600"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.6774,
    cy: 139.33073,
    r: 5.16936,
    fill: "#ff6600"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 407.3887,
    y: 77.29839,
    width: 98.2179,
    height: 8.27098,
    fill: "#ff6600"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 407.3887,
    y: 106.24682,
    width: 98.2179,
    height: 8.27098,
    fill: "#ff6600"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 407.3887,
    y: 135.19525,
    width: 98.2179,
    height: 8.27098,
    fill: "#ff6600"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "550.665 639.737 538.405 639.736 532.573 592.448 550.667 592.449 550.665 639.737",
    fill: "#9f616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M710.73392,775.42958l-39.53076-.00146v-.5a15.38731,15.38731,0,0,1,15.38648-15.38623h.001l24.144.001Z",
    transform: "translate(-156.9425 -123.80875)",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "664.665 639.737 652.405 639.736 646.573 592.448 664.667 592.449 664.665 639.737",
    fill: "#9f616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M824.73392,775.42958l-39.53076-.00146v-.5a15.38731,15.38731,0,0,1,15.38648-15.38623h.001l24.144.001Z",
    transform: "translate(-156.9425 -123.80875)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M702.72093,523.57062s-10.29059,27.93152-8.8205,39.69214-10.29053,94.08515-8.82049,101.43555-1.4701,44.10242,0,49.98273-4.126,12.904-1.18583,18.78433,7.06614,17.96768,7.06614,17.96768l19.111-1.47009,2.94018-16.1709s8.8205-1.47009,7.35041-10.29059,7.3504-67.62366,7.3504-67.62366l24.99133-82.32446,35.28192,74.97406s1.4701,52.92285,5.88031,58.80316-4.41021,22.05121,0,27.93152,8.8205,16.1709,8.8205,16.1709h22.05121V739.67237s13.23071-7.3504,0-29.40161l-8.94019-132.42688-8.82049-60.27326Z",
    transform: "translate(-156.9425 -123.80875)",
    fill: "#2f2e41"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 600.5805,
    cy: 187.45592,
    r: 27.45748,
    fill: "#a0616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M734.15719,309.37058q2.90616,7.42524,5.81249,14.85045c2.38187,6.0855,5.10983,12.59627,10.693,15.99248,6.89335,4.19321,16.09891,2.14859,22.76738-2.39371a35.55267,35.55267,0,0,0-16.0025-64.70912l-.27595,4.97045-6.09928-5.11247a5.92961,5.92961,0,0,1-9.21737,1.30354c1.6022,3.32109-.24695,7.37161-2.91728,9.91573-3.28072,3.12533-12.66394,6.88145-12.27456,12.46855C726.903,300.3849,732.64485,305.50673,734.15719,309.37058Z",
    transform: "translate(-156.9425 -123.80875)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M833.10409,564.18693a11.62612,11.62612,0,0,0-4.98194-17.117l.54864-26.56207-16.06038-4.27033-.24794,37.52166a11.68914,11.68914,0,0,0,20.74162,10.42776Z",
    transform: "translate(-156.9425 -123.80875)",
    fill: "#9f616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M777.91953,355.69214s-21.27734-10.63867-41.37262-3.54623-30.734,15.367-30.734,15.367l13.00281,68.56037-17.73108,92.20187s91.01984-7.09247,99.29431,0,8.27454-8.27453,8.27454-8.27453L801.561,432.527l13.00287-55.55752Z",
    transform: "translate(-156.9425 -123.80875)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M688.11533,565.75982a11.62611,11.62611,0,0,0,.02419-17.82727l7.98411-25.33966-14.21547-8.60767-10.77251,35.94287a11.68915,11.68915,0,0,0,16.97968,15.83173Z",
    transform: "translate(-156.9425 -123.80875)",
    fill: "#9f616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M714.08744,367.51291H705.8129s-13.00284,8.27454-13.00284,20.09528-18.91317,150.12363-18.91317,150.12363l20.09527,3.5462,17.73114-96.93021,13.00287-26.00567Z",
    transform: "translate(-156.9425 -123.80875)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M792.10447,376.96952h22.45941s7.09247,7.09244,10.63867,23.64151,7.09247,81.5632,7.09247,81.5632L829.93088,541.278H812.19974l-2.36413-76.8349L798.01487,414.796Z",
    transform: "translate(-156.9425 -123.80875)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M961.78346,776.19125h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-156.9425 -123.80875)",
    fill: "#cbcbcb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawSelectOptionReU4Qn);
export default __webpack_public_path__ + "static/media/undraw_select_option_re_u4qn.798a70a527cc892090d7f4d297039723.svg";
export { ForwardRef as ReactComponent };